module.exports = __webpack_public_path__ + "img/flug-machine.c041ae82.jpg";